<template>
  <b-row>
    <b-col cols="12">
      <b-card>

        <b-card-text>
          <b-tabs v-model="activeTab" class="profile-tabs">
            <b-tab>
              <template slot="title">
                <i class="fa fa-cogs pr-1"></i> Profile Settings
              </template>
              <!-- settings component -->
              <common-settings :auth-data="auth" />
            </b-tab>
            <b-tab>
              <template slot="title">
                <i class="fa fa-key pr-1" ></i> API Access Tokens
              </template>
              <!-- keys component -->
              <long-lived-api-keys :auth-data="auth" />
            </b-tab>
          </b-tabs>
        </b-card-text>
      </b-card>
    </b-col>
  </b-row>
</template>


<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import CommonSettings from '../components/profile/CommonSettings';
import LongLivedApiKeys from '../components/profile/LongLivedApiKeys';

  export default {
    name: 'profile',
    components: {
      LongLivedApiKeys,
      CommonSettings
    },
    data() {
      return {
        activeTab: 0,

        auth: {
          apiToken: null,
          user: {},
          admin: false,
          trial_user: false,
          trial_expiry: 0,
          user_authorization: {},
        },
      };
    },
    async mounted() {
      await this.getUserData();
    },
    methods: {
      ...mapActions('api', ['getUser', 'getToken']),
      login() {
        // this.$auth.loginWithRedirect();
      },
      async getUserData() {
        this.auth.apiToken = await this.getToken();
        this.auth.user = await this.getUser();
        let roles = this.auth.user['https://app.oceanbolt.com/roles'] || [];
        this.auth.trial_user = this.auth.user['https://app.oceanbolt.com/trial_user'] || false;
        this.auth.trial_expiry = this.auth.user['https://app.oceanbolt.com/trial_expiry'] || 0;
        this.auth.admin = this.auth.user['https://app.oceanbolt.com/user_authorization'].permissions.includes("admin") || false
        this.auth.user_authorization = this.auth.user['https://app.oceanbolt.com/user_authorization'] || {};
      },
    },
    computed: {
      trial_expiry_string: function() {
        return 'Expires: ' + moment(this.auth.trial_expiry).format('MMMM Do YYYY');
      }
    }
  }
</script>

<style lang="scss">
  .picture-container {
    display: flex;
    justify-content: right;
    align-items: flex-end;
    float: right;
  }

  .profile-pic {
    display: block;
    max-width:400px;
    max-height:400px;
    width: auto;
    height: auto;
    border-radius: 50%;
  }

  .profile-tabs {
    .nav-tabs {
      border-bottom: 1px solid #676767;
    }

    .nav-tabs .nav-link {
      border-color: #676767;
      border-bottom: none;
      outline: none;
    }

    .nav-tabs .nav-link.active {
      border-color: #bebebe;
    }

    .nav-tabs .nav-link:hover {
      border-color: #bebebe;
    }
  }
</style>

<style lang="scss" scoped>
</style>
